<template>
  <donut-chart-card
    :size="size"
    :title="title"
    :value="data"
    :init-total="total"
    unit="개소"
    :isMoveWrite="isMoveWrite"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
    @item="onClickItem"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart45',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    size: String,
    reloadCount: Number,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    projectInfo () {
      return this.$store.state.project.projectInfo

    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    },
    reloadCount () {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 45,
      title: '공중교통수단 현황',
      isMoveWrite: false,
      data: [{label: '데이터 없음', value: 0}],
      total: 0,
    }
  },
  async mounted () {
    await this.loadGraph()
  },
  methods: {
    async loadGraph () {
      const donutData = await this.$store.dispatch('summary/LOAD_DONUT_35', {
        projectId: this.projectId,
        depth: 1,
        fieldCode: 'public-transportation',
      });
      // console.log('donut35', this.getLevel, {type: this.dataType, donutData});

      let tmpData = {};
      const parsedData = [];
      switch (this.dataType) {
      case 'project':
        tmpData = donutData.project;
        break;
      case 'company':
        tmpData = donutData.company;
        break;
      case 'field':
        tmpData = donutData.field;
        break;
      case 'field_cat1':
      case 'detail':
        // if (this.getLevel === 4) {
        //   tmpData = donutData.field;
        //   this.title = '시설물 참여 업체 수';
        // } else {
        tmpData = donutData.facility_category;
        // }
        break;
      }
      const currentYear = new Date().getFullYear();

      let rowsSum = 0;
      if (Object.keys(tmpData).length > 0) {
        for (const key of Object.keys(tmpData)) {
          parsedData.push({
            label: tmpData[key].label,
            value: tmpData[key].yearly[currentYear],
          });
          rowsSum += tmpData[key].yearly[currentYear];
        }
        this.data = parsedData;
      }

      // 합계는, 전체 분야 데이터에서 가져온다
      let projectTotal = 0;
      for (const projectItem of donutData.project) {
        projectTotal += projectItem.yearly[currentYear];
      }
      this.total = projectTotal;

      // Lv.4이고, 사업장 개수를 반환할 떄에는, 전체 참여 업체 수를 내보내도록 한다
      if (this.getLevel === 4 && this.dataType === 'detail') {
        this.total = rowsSum;
      }
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      this.$router.push({name: 'field-workplace-create', params: {proj_id}})
    },
    onClickItem () {
      if (Number(`${this.projectId}`) === 2) {
        this.$router.push('/project/1/field/info/type-a')
      } else if (Number(`${this.projectId}`) === 3) {
        this.$router.push('/project/1/field/info/type-b')
      } else if (Number(`${this.projectId}`) === 4) {
        this.$router.push('/project/1/field/info/type-c')
      } else if (Number(`${this.projectId}`) === 5) {
        this.$router.push('/project/1/field/info/type-d')
      }
    }
  },
}
</script>

<style scoped>

</style>
